import React, { useState, useEffect } from 'react'
import { GoogleMap, LoadScript, Marker, InfoWindow } from "@react-google-maps/api"
import { secureApi } from '../../Config/api'
import { GET } from '../../utils/apis'

const libraries = ['geometry']
const GOOGLE_MAPS_API_KEY = 'AIzaSyAOvlaMKD4C0dPSjCtNOi-DnwkW8s4pSbI'

const DeviceMap = ({ device }) => {
    const [location, setLocation] = useState({ lat: 45.4642, lng: 9.19 })
    const [selectedMarker, setSelectedMarker] = useState(false)
    const [hasLocation, setHasLocation] = useState(false)

    const parseCoordinate = (coord) => {
        if (!coord) return null;
        const val = parseFloat(coord.toString().replace(/[NSEW]/g, ''));
        return isNaN(val) ? null : val;
    }

    useEffect(() => {
        if (device?.device_serial) {
            fetchLocation();
        } else {
            setHasLocation(false);
        }
    }, [device])

    const fetchLocation = async () => {
        try {
            const response = await secureApi.get(GET?.GET_DEVICE_LOCATION, {
                params: { serial_number: device?.device_serial }
            })

            if (response?.success && response?.data) {
                const lat = parseCoordinate(response.data.latitude);
                const lng = parseCoordinate(response.data.longitude);

                if (lat !== null && lng !== null) {
                    setLocation({ lat, lng });
                    setHasLocation(true)
                } else {
                    setHasLocation(false)
                }
            } else {
                setHasLocation(false)
            }
        } catch (error) {
            console.error("Location fetch error:", error)
            setHasLocation(false);
        }
    }

    return (
        <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY} libraries={libraries}>
            <GoogleMap
                mapContainerStyle={{ width: '100%', height: '100%' }}
                center={location}
                zoom={hasLocation ? 15 : 12}
                options={{
                    gestureHandling: 'greedy',
                    mapTypeControl: false,
                    streetViewControl: false
                }}
            >
                {hasLocation && (
                    <Marker
                        position={location}
                        onClick={() => setSelectedMarker(true)}
                    />
                )}

                {selectedMarker && hasLocation && (
                    <InfoWindow
                        position={location}
                        onCloseClick={() => setSelectedMarker(false)}
                    >
                        <div style={{ lineHeight: '1.6', minWidth: '180px' }}>
                            <div><b>  Lat: {location.lat.toFixed(6)}</b> </div>
                            <div><b>  Lng: {location.lng.toFixed(6)}</b>  </div>
                        </div>
                    </InfoWindow>
                )}
            </GoogleMap>
        </LoadScript>
    )
}

export default DeviceMap